import { Button, Result } from 'antd'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { RNHome } from '../helpers/routeNames'

export const Page404: FC = () => {
	const navigate = useNavigate()

	return (
		<>
			<Result
				style={{
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center'
				}}
				status="404"
				title="404"
				subTitle={'PageNotFound'}
				extra={
					<>
						<Button
							type="primary"
							onClick={() => navigate(-1)}>
							GoBack
						</Button>
						<Button
							type="primary"
							onClick={() => navigate(RNHome)}>
							GoHome
						</Button>
					</>
				}
			/>
			<style>{`.ant-result-image {margin-top: 24px!important}`}</style>
		</>
	)
}
